import { useState, useEffect } from 'react';
import { hotPluginManager } from '../client/HotPluginManager';
import { ModuleManifest } from '../services/ModuleScanner';

export function useModuleCatalog() {
  const [modules, setModules] = useState<ModuleManifest[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const update = () => {
      setModules(hotPluginManager.getModules());
      setLoading(false);
    };

    hotPluginManager.fetchCatalog().then(update);
    const unsubscribe = hotPluginManager.subscribe(update);
    return () => unsubscribe();
  }, []);

  return {
    coreModules: modules.filter(m => m.isCore),
    decoupledModules: modules.filter(m => !m.isCore),
    loading
  };
}
